module.exports = ".sidemenu{\r\n    background:#f3f3f3;\r\n}\r\n\r\n.sidemenu ul.billmenu{\r\n    padding-left:0px;\r\n    list-style: none;\r\n}\r\n\r\n.sidemenu ul.billmenu li a{\r\n    display: block !important;\r\n    width: 100%;\r\n    padding: 10px 15px;\r\n    font-size: 14px;\r\n    color: #444;\r\n    /* transition: .5s; */\r\n    text-decoration: none;\r\n}\r\n\r\n.sidemenu ul.billmenu li a:hover{\r\n    background: #3aceff;\r\n    color:#fff;\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/recovery/payment-receipt-approval/payment-receipt-approval.component.css
// module id = ./src/app/recovery/payment-receipt-approval/payment-receipt-approval.component.css
// module chunks = main